import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import CurrencyInput from "react-currency-input-field";
import { squadLogo } from "@/assets";

const Squad = () => {
  const [amount, setAmount] = useState(null);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!amount || amount <= 0) {
      toast.error("Please enter a valid amount");
      setLoading(false);
      return;
    }

    try {
      const squadInstance = new window.squad({
        onClose: () => {
          // console.log("Widget closed");
          setLoading(false);
          toast.info("Payment window closed");
        },
        onLoad: () => console.log("Widget loaded successfully"),
        onSuccess: () => {
          // console.log(`Linked successfully`);
          setLoading(false);
          navigate("/payment-successful");
          toast.success("Payment successful");
        },
        key: user.meta_data.squad_public_key,
        email: user.email,
        amount: amount * 100,
        currency_code: "NGN",
      });

      squadInstance.setup();
      squadInstance.open();
    } catch (error) {
      console.error(error);
      toast.error("Payment initialization failed");
      setLoading(false);
    }
  };

  return (
    <div className="dark:bg-darkInput rounded-[20px] bg-white p-4 shadow">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img src={squadLogo} alt="" />
        </div>
      </div>
      <div className="py-3 text-sm opacity-80">
        Fund your wallet instantly via card, bank transfer, or USSD. Your
        account will be credited automatically.
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <div className="dark:border-darkBorder dark:bg-darkInput flex items-center gap-x-3 rounded-xl border bg-gray-50 p-2 py-2.5">
          <CurrencyInput
            name="amount"
            placeholder="Input amount (₦)"
            value={amount}
            onValueChange={(value) => setAmount(value)}
            className="w-full border-none bg-transparent text-sm outline-none dark:text-white"
            required
            prefix="₦ "
          />
        </div>

        <button
          type="submit"
          className={`bg-primary focus:bg-primary w-full rounded-xl py-3 font-semibold text-white ${loading && "opacity-65"}`}
          disabled={loading}
        >
          {loading ? "Processing..." : "Proceed"}
        </button>
      </form>
    </div>
  );
};

export default Squad;
